module.exports = __webpack_public_path__ + "img/contacts.bd06c34d.svg";